var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-option',_vm._b({ref:"elementOption",attrs:{"id":_vm.optionId,"aria-selected":("" + _vm.isSelected),"role":"option"}},'el-option',_vm.$attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }